import script from "./StatsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./StatsPage.vue?vue&type=script&setup=true&lang=js"

import "./StatsPage.vue?vue&type=style&index=0&id=f3479f66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3479f66"]])

export default __exports__